const localNotifications = {
  'local-notifications-breadcrumbs': 'Local notifications',
  'local-notifications-filter-title': 'Local notifications filter',
  'local-notifications-form-id-placeholder': 'Notification ID',
  'local-notifications-form-title-placeholder': 'Notification title',
  'unable-edit-sended-item-notification': 'Unable to edit, current data is already sended',
};

export default localNotifications;
